const state = {
  lessonId: null, //当前所在直播间
  lessonList: {}, //课时列表
};

const mutations = {
  setLessonId: (state, id) => {
    state.lessonId = Number(id);
    console.log(state.lessonId, "state.lessonId====");
  },
  setLessonList: (state, data) => {
    state.lessonList[data.lesson_id] = { ...data };
    // 存储已经弹出的lesson_id
    let ids = localStorage.getItem("havedShowLessonIds");
    if (ids) {
      ids = JSON.parse(ids);
      ids.push(data.lesson_id);
      localStorage.setItem("havedShowLessonIds", JSON.stringify(ids));
    } else {
      localStorage.setItem(
        "havedShowLessonIds",
        JSON.stringify([data.lesson_id])
      );
    }

    console.log(state.lessonList, "state.lessonList====");
  },
  delLessonList: (state, id) => {
    delete state.lessonList[id];
    console.log(state.lessonList, "delLessonList--state.lessonList====");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
